<template>
  <div>
    <slot v-if="isLoggedIn" />
    <slot 
      v-else-if="!toggle"
      name="fallback"
    >
      <access-denied />
    </slot>
  </div>
</template>
<script>
  import { mapState } from 'pinia'  
  import { useAuthStore } from '@/store/auth-store'

  export default {
    name: 'LoggedIn',
    props: {
      toggle: Boolean,
    },
    computed: {
      ...mapState(useAuthStore, ['isLoggedIn']),
    },
  }
</script>
